<template>
  <div class="top">
    <div class="top_container">
      <RoomCardList :search_conditions="search_conditions"/>
    </div>
    <!--SP用フッター-->
    <div class="sp footer" :class="{hidden: footer_is_hidden}">
      <SearchFooter/>
    </div>

  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import RoomCardList from '../components/RoomCardList'
  import SearchFooter from '../components/SearchFooter'
  import Ajax from '../assets/js/Ajax'
  import Util from '../assets/js/Util'

  export default {
    name: 'Top',
    components: { RoomCardList, SearchFooter },
    data: () => ({
      footer_is_hidden: false,
      callback: () => {}
    }),
    computed: {
      ...mapState('search', ['search_conditions']),
    },
    async created() {
      this.checkQueryParams();
      window.addEventListener('popstate', this.checkQueryParams);
    },
    mounted() {
      const app = document.getElementById('app');
      const footer = this.$el.querySelector('.sp.footer');
      this.callback = () => this.footer_is_hidden = !Util.detectCollision(app, footer);
      window.addEventListener('scroll', this.callback);
      this.callback();
    },
    beforeDestroy() {
      window.removeEventListener('popstate', this.checkQueryParams);
      window.removeEventListener('scroll', this.callback);
    },
    methods: {
      ...mapMutations('search', ["setSearchConditions", "updateSearchText"]),
      async checkQueryParams() {
        const search_params = new URLSearchParams(location.search);

        //URLから検索ワードを取得
        const search_text = search_params.get('search_text');
        if ( search_text ) this.updateSearchText(search_text);

        //new Setで重複を省いておく
        const query_tags = [...new Set( search_params.getAll('tags[]') )];
        const query_tags_en = [...new Set( search_params.getAll('tags_en[]') )];
        if ( !query_tags.length && !query_tags_en.length ) return;

        const tag_data = await Ajax.getTagData();
        const input_tags = [...query_tags
          .map(tag => tag_data.find(d => d.name_ja === tag)),
          ...query_tags_en.map(tag => tag_data.find(d => d.name_en === tag))]
                .filter(d => d)
          .filter((tag, index, self) => self.findIndex(d => d.id === tag.id) === index)
                .sort((a,b) => (+a.sort_no) - (+b.sort_no));
        this.setSearchConditions(input_tags);
      }
    }
  }
</script>

<style scoped lang="scss">
  .top{
    background-color: #F2F2F2;
    box-shadow: 0 2px 4px #d1d1d1 inset;
    padding-bottom: 500px;

    .top_container{
      max-width: 1100px;
      margin: auto;
      padding: 20px 2rem 0;
    }
  }

  @media screen and (max-width:639px) {
    .top{
      /*background-color: #ffffff;*/
      padding-bottom: 100px;
      box-shadow: initial;
      .top_container{
        /*padding: 20px 1.8rem 100px;*/
        padding: 20px 0 100px;
      }
    }
    .footer{
      position: fixed;
      bottom: -1px;
      z-index: 10;
      width: 100%;
      transition: 0.3s ease;
      &.hidden{
        opacity: 0;
        visibility: hidden;
      }
    }
  }
</style>
